import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTeamMessages, removeTeamMessage, updateTeamMessage } from 'slice/teamMessageSlice';
import AdminTable from 'common/AdminTable';
// import { toast } from "react-toastify";

const ListTeamMessage = () => {
  const dispatch = useDispatch();
  const ASSET_BASE_URL = process.env.REACT_APP_BACKEND_URL_REL;

  const { data: messageList } = useSelector((state) => state.teamMessage);

  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image: null,
    existingImage: ''
  });
  console.log('ASSET_BASE_URL =', ASSET_BASE_URL);

  // Fetch list on mount
  useEffect(() => {
    dispatch(getTeamMessages());
  }, [dispatch]);

  // Edit button click
  const handleEditClick = (message) => {
    setSelectedMessage(message);
    setFormData({
      name: message.name,
      description: message.description,
      image: null,
      // existingImage: message.image ? `${process.env.REACT_APP_BACKEND_URL}uploads/messages/${message.image}` : "",
      existingImage: message.image ? `${ASSET_BASE_URL}messages/${message.image}` : ''
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedMessage(null);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { files } = e.target;
    setFormData((prev) => ({ ...prev, image: files[0] }));
  };

  // const handleSaveChanges = async () => {
  //   const updatedData = new FormData();
  //   Object.entries(formData).forEach(([key, value]) => {
  //     if (key === "image") {
  //       if (value) updatedData.append(key, value);
  //     } else if (!key.startsWith("existing")) {
  //       updatedData.append(key, value);
  //     }
  //   });

  //   try {
  //     await dispatch(updateTeamMessage({ id: selectedMessage.id, data: updatedData }));
  //     toast.success("Team message updated successfully");
  //     dispatch(getTeamMessage());
  //     closeModal();
  //   } catch (err) {
  //     toast.error("Failed to update team message");
  //   }
  // };

  // Table Headers
  const handleSaveChanges = () => {
    if (!selectedMessage) return;

    const data = new FormData();
    data.append('name', formData.name);
    data.append('description', formData.description);

    if (formData.image) {
      data.append('image', formData.image);
    }

    dispatch(updateTeamMessage({ id: selectedMessage.id, data }));
    closeModal(); // saga handles toast + refresh
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) => (
        // <img
        //   src={`${process.env.REACT_APP_BACKEND}uploads/messages/${row.original.image}`}
        //   alt={row.original.name}
        //   width={100}
        // />
        <img
          src={`${ASSET_BASE_URL}messages/${row.original.image}`}
          alt={row.original.name}
          width={100}
          onError={(e) => (e.currentTarget.src = '/no-image.png')}
        />
      )
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Description', accessor: 'description' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => dispatch(removeTeamMessage(row.original.id))}>
            Remove
          </button>
          <button className="btn btn-primary mx-1" onClick={() => handleEditClick(row.original)}>
            Edit
          </button>
        </>
      )
    }
  ];

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Team Message List</h4>
        </div>
        {messageList?.length > 0 && <AdminTable tableHeaders={tableHeaders} tableData={messageList} />}
      </div>

      {/* Modal */}
      {showModal && selectedMessage && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          {/* <div className="modal-dialog modal-dialog-centered modal-lg" role="document"> */}

          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Team Message</h5>
                <button type="button" className="close" onClick={closeModal}>
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                {['name', 'description'].map((field) => (
                  <input
                    key={field}
                    type="text"
                    name={field}
                    value={formData[field]}
                    onChange={handleFormChange}
                    placeholder={field}
                    className="form-control mb-2"
                  />
                ))}

                <input type="file" name="image" onChange={handleFileChange} className="form-control mb-2" />

                {formData.image ? (
                  <img src={URL.createObjectURL(formData.image)} width={100} alt="preview" />
                ) : formData.existingImage ? (
                  <img src={formData.existingImage} width={100} alt="existing" />
                ) : null}
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSaveChanges}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListTeamMessage;
